export const coAcceptanceTable = [
  {
    source: 'ordered_part_id',
    sortable: true,
    title: 'Id',
    selectable: true,
  },
  {
    source: 'ordered_part_po',
    sortable: true,
    title: 'PO',
    selectable: true,
  },
  {
    source: 'ordered_part_status',
    sortable: true,
    title: 'Status',
    selectable: true,
  },
  {
    source: 'ordered_part_tracking',
    sortable: true,
    title: 'Tracking',
    selectable: true,
  }, {
    source: 'ordered_part_est_delivery_date',
    sortable: true,
    title: 'Est Delivery',
    selectable: true,
  },
  {
    source: 'ordered_part_brand',
    sortable: true,
    title: 'Brand',
    selectable: true,
  },
  {
    source: 'ordered_part_mpn',
    sortable: true,
    title: 'Mpn',
    selectable: true,
  },
  {
    source: 'ordered_part_qty_delivered',
    sortable: true,
    title: 'Delivered',
    selectable: true,
  },
  {
    source: 'ordered_part_qty_in_order',
    sortable: true,
    title: 'Ordered',
    selectable: true,
  },
  {
    source: 'ordered_part_included',
    sortable: false,
    title: 'Included',
    selectable: true,
  }
];

export default coAcceptanceTable;
